/**
 * ModuleDoorInteractSide enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file ModuleDoorInteractSide.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @enum
 */
export enum ModuleDoorInteractSide {
  SIDE_1 = 1,
  SIDE_2 = 2,
}